// frontend\src\components\Pagination.js
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    // Если страниц нет или только одна, не показываем пагинацию
    if (totalPages <= 1) return null;

    const pageNumbers = [];
    
    // Показываем только ближайшие страницы для лучшего UX
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    
    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    return (
        <nav aria-label="Page navigation">
            <ul className="pagination justify-content-center">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button 
                        className="page-link" 
                        onClick={() => onPageChange(currentPage - 1)}
                        aria-label="Previous"
                    >
                        &laquo;
                    </button>
                </li>
                
                {/* Первая страница с многоточием если нужно */}
                {startPage > 1 && (
                    <>
                        <li className="page-item">
                            <button 
                                className="page-link" 
                                onClick={() => onPageChange(1)}
                            >
                                1
                            </button>
                        </li>
                        {startPage > 2 && (
                            <li className="page-item disabled">
                                <span className="page-link">...</span>
                            </li>
                        )}
                    </>
                )}
                
                {pageNumbers.map(number => (
                    <li 
                        key={number} 
                        className={`page-item ${currentPage === number ? 'active' : ''}`}
                    >
                        <button 
                            className="page-link" 
                            onClick={() => onPageChange(number)}
                        >
                            {number}
                        </button>
                    </li>
                ))}
                
                {/* Последняя страница с многоточием если нужно */}
                {endPage < totalPages && (
                    <>
                        {endPage < totalPages - 1 && (
                            <li className="page-item disabled">
                                <span className="page-link">...</span>
                            </li>
                        )}
                        <li className="page-item">
                            <button 
                                className="page-link" 
                                onClick={() => onPageChange(totalPages)}
                            >
                                {totalPages}
                            </button>
                        </li>
                    </>
                )}
                
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button 
                        className="page-link" 
                        onClick={() => onPageChange(currentPage + 1)}
                        aria-label="Next"
                    >
                        &raquo;
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default Pagination;